import React, { useState, useEffect, useRef, useContext } from "react";

import styles from "./styles/CredentialsMenu.module.css";
import { LanguageContext } from "../../../Context/changeLanguageProvider";

function CredNotStored({ onChange, value, formErrors }) {
  const [showOptions, setShowOptions] = useState(false);
  const wrapperRef = useRef();
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.EditAsset.CredNotStored
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.EditAsset.CredNotStored);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const bottomRef1 = useRef(null);
  const bottomRef2 = useRef(null);
  const [data, setData] = useState({
    service_name: value ? JSON.parse(value).service_name || "" : "",
    username: value ? JSON.parse(value).username || "" : "",
    password: value ? JSON.parse(value).password || "" : "",
    mfa: value ? JSON.parse(value).mfa || "" : "",
  });
  const [error, setError] = useState({
    service_name: "",
    username: "",
    password: "",
  });
  const errorMessages = {
    service_name: content.credNotStoredText1,
    username: content.credNotStoredText2,
    password: content.credNotStoredText3,
  };
  const resetError = () => {
    Object.keys(error).forEach((key) => {
      setError((prevError) => ({ ...prevError, [key]: null }));
    });
  };
  const editData = (key, value) => {
    setData({ ...data, [key]: value });
    onChange({ ...data, [key]: value });
  };
  useEffect(() => {
    onChange(data);
    if (bottomRef1.current) {
      bottomRef1.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, []);

  useEffect(() => {
    const emptyKeys = Object.keys(formErrors)
      .filter((key) => formErrors[key] === "error")
      .map((key) => key);
    emptyKeys.forEach((key) => {
      if (formErrors[key] === "error") {
        setError((prevError) => ({ ...prevError, [key]: errorMessages[key] }));
      }
    });

    setTimeout(() => {
      resetError();
    }, 5000);
  }, [formErrors]);

  const handleClick = (e) => {
    setShowOptions(false);
    editData("mfa", e.target.innerText);
  };
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  // password hide/show
  const isPasswordVisible = (fieldName) => {
    return passwordVisibility[fieldName];
  };
  const [passwordVisibility, setPasswordVisibility] = useState({});

  const handleTogglePassword = (fieldName) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };
  useEffect(() => {
    if (showOptions) {
      if (bottomRef2.current) {
        bottomRef2.current.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    } else {
      wrapperRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [showOptions]);
  return (
    <div className={styles.cred_field}>
      <div className={styles.field_wrap}>
        <div
          className={`${styles.field} ${
            error?.service_name ? styles.field_error : ""
          }`}
        >
          <div className={`${styles.input_title} ${styles.required_field}`}>
            {content.credNotStoredText4}
          </div>
          <input
            value={data.service_name}
            onChange={(e) => editData("service_name", e.target.value)}
            className={styles.user_input}
            placeholder={dublicatedcontent.dublicatedText92}
          ></input>
          {error?.service_name ? (
            <div className={styles.error_message}>{error.service_name}</div>
          ) : null}
        </div>
        <div
          className={`${styles.field} ${
            error?.username ? styles.field_error : ""
          }`}
        >
          <div className={`${styles.input_title} ${styles.required_field}`}>
            {content.credNotStoredText5}
          </div>
          <input
            value={data.username}
            onChange={(e) => editData("username", e.target.value)}
            className={styles.user_input}
            placeholder={content.credNotStoredText5}
          ></input>
          {error?.username ? (
            <div className={styles.error_message}>{error.username}</div>
          ) : null}
        </div>
      </div>
      <div className={styles.field_wrap}>
        <div
          className={`${styles.field} ${
            error?.password ? styles.field_error : ""
          }`}
        >
          <div className={`${styles.input_title} ${styles.required_field}`}>
            {dublicatedcontent.dublicatedText62}
          </div>
          <input
            value={data.password}
            onChange={(e) => editData("password", e.target.value)}
            className={styles.user_password}
            placeholder={dublicatedcontent.dublicatedText62}
            type={isPasswordVisible("passwordField") ? "text" : "password"}
            name="passwordField"
          ></input>
          <div
            onClick={() => handleTogglePassword("passwordField")}
            className={styles.password_button}
          >
            <svg
              width="18"
              height="15"
              viewBox="0 0 18 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                fill="#B3B3B3"
              />
              <path
                d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                fill="#B3B3B3"
              />
            </svg>
          </div>
          {error?.password ? (
            <div className={styles.error_message}>{error.password}</div>
          ) : null}
        </div>
        <div className={styles.field}>
          <div className={`${styles.input_title}`}>
            {content.credNotStoredText7}
          </div>
          <div
            ref={wrapperRef}
            onClick={() => {
              setShowOptions(!showOptions);
            }}
            className={styles.select}
          >
            {data.mfa ? data.mfa : "None"}
            {!showOptions ? (
              <div className={styles.down} />
            ) : (
              <>
                <div className={styles.up} />
                <div className={styles.dropdown}>
                  <div
                    onClick={(e) => handleClick(e)}
                    className={styles.option}
                  >
                    {dublicatedcontent.dublicatedText62}
                  </div>
                  <div
                    onClick={(e) => handleClick(e)}
                    className={styles.option}
                  >
                    {content.credNotStoredText9}
                  </div>
                  <div
                    onClick={(e) => handleClick(e)}
                    className={styles.option}
                  >
                    {content.credNotStoredText10}
                  </div>
                  <div
                    onClick={(e) => handleClick(e)}
                    className={styles.option}
                    ref={bottomRef2}
                  >
                    {content.credNotStoredText11}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>{" "}
      <div ref={bottomRef1}></div>
    </div>
  );
}

export default CredNotStored;
